export const getCustomItems = (orderDetailData: any) => {
  if (orderDetailData && orderDetailData.items) {
    return orderDetailData.items
      .filter((el: any) => el.itemCode.indexOf(`${el.documentNo}-custom`) > -1)
      .map(({ itemCode }: any) => itemCode);
  }
  return [];
};
